<mat-form-field class="controls-alignment" [formGroup]="group">
  @if (field.description) {
    <p [innerHTML]="field.description"></p>
  }
  <mat-label>{{field.labelName}}</mat-label>
  <input matInput [formControlName]="field.labelCode" type="text" autocomplete="off" [matAutocomplete]="auto" tabindex="-1" [required]="isRequired">
  <mat-autocomplete #auto="matAutocomplete" tabindex="-1" (optionSelected)="selectionOptionChanged($event)">
    @for (item of (massDropdown | async); track item) {
      <mat-option [id]="item.code">
        {{item.value}}
      </mat-option>
    }
    @if (noData) {
      <mat-option id="{{noRecord}}">
        No records found.
      </mat-option>
    }
  </mat-autocomplete>
  @for (validation of field.validations; track validation) {
    <ng-container ngProjectAs="mat-error">
      @if (group.get(field.labelCode).hasError(validation.name.toLocaleLowerCase())) {
        <mat-error>{{validation.message}}</mat-error>
      }
    </ng-container>
  }
</mat-form-field>
